<template>
    <div class="contents">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Rekening Bank
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <a v-on:click="openCreate" class="btn px-15 btn-primary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Tambah Rekening
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <BankAccountTable />
                    </div>
                </div>
            </div>
            <modal name="new_bank_account" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddBankAccount :defaultValue="editData" />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import BankAccountTable from "@/components/tables/BankAccount.vue";
    import AddBankAccount from "@/components/forms/bank-account/Add.vue";

    export default {
        components: {
            BankAccountTable,
            AddBankAccount
        },
        data() {
            return {
                editData: null
            };
        },
        beforeDestroy() {
            this.$root.$off("toggle_modal", this.fnToggleModal);
            this.$root.$off("edit_bank_account", this.fnEditAccount);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.$modal.toggle(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            this.fnEditAccount = (row) => {
                this.editData = row;
                this.$modal.toggle('new_bank_account');
            }
            this.$root.$on("edit_bank_account", this.fnEditAccount);
        },
        methods: {
            openCreate() {
                this.editData = null;
                this.$modal.toggle('new_bank_account');
            },
        },
    };
</script>
